import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=8718874c&scoped=true&"
import script from "./ServiceConfig.vue?vue&type=script&lang=js&"
export * from "./ServiceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8718874c",
  null
  
)

export default component.exports